module.exports = "/images/checkbox-inactive.svg?d0d0052bd7a4827b0ac917703776f322";